// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__UnRhr","tabs__item":"styles_tabs__item__uly4o","active":"styles_active__Y2aCO","tabs__list":"styles_tabs__list__Y2Rgu","tabs__tab":"styles_tabs__tab__YXqbh"};